import { render, staticRenderFns } from "./Hospitalizacion.vue?vue&type=template&id=de446632&scoped=true"
import script from "./Hospitalizacion.vue?vue&type=script&lang=js"
export * from "./Hospitalizacion.vue?vue&type=script&lang=js"
import style0 from "./Hospitalizacion.vue?vue&type=style&index=0&id=de446632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de446632",
  null
  
)

export default component.exports